import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import {
  loadRecommendationsForTouristRoutes
} from "@common/redux/slices/recommendation.slice";
import { loadRoute } from "@common/redux/slices/touristroutes.slice";
import { SingleTouristsRoutes } from "@kursk/components/pages/SingleTouristRoutes/SingleTouristsRoutes";
import { loadFeedbacks } from "@common/redux/slices/feedbacks.slice";

export default function page({ notFound }) {

  if (notFound) {
    return (<NotFoundPage/>);
  }
  return <SingleTouristsRoutes /> ;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, params }) => {
  const { id } = params;
  await Promise.all([
    store.dispatch(loadRoute({ id: Number(id) })),
    store.dispatch(loadRecommendationsForTouristRoutes({ id: Number(id) })),
    store.dispatch<any>(loadFeedbacks({ type: 'touristRoute', touristRouteId: Number(id) })),
  ]);
  const { touristRoute } = store.getState().touristRoutes;

  if (!touristRoute?._id) {
    return {
      props: { notFound: true }
    };
  }
});
